import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const dbIndicator: ThemeApp['appComponents']['dbIndicator'] = {
  statusCircleIndicator: {
    border: themeUi.semantic.color.border.neutral100
  },
  statusContainer: {
    color: themeUi.semantic.color.text.neutral800
  },
  statusItem: {
    borderBottom: themeUi.semantic.color.border.neutral400
  },

  components: {
    dBProcesses: {
      components: {
        dBProcess: {
          text: {
            color: themeUi.semantic.color.text.danger500
          }
        }
      }
    }
  }
};

export default dbIndicator;
